'use strict';

/*

  DynamicEditAddressForm

  Dynamically assign action based on this._getEndpoint() method 
  ie if they have address in new format or not
  
  Ref: New address format - https://mogofintech.atlassian.net/browse/ACCT-596

*/

function DynamicEditAddressForm() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [_ErrorController];
  this._history = new History();
  this._analytics = new Analytics();
  this._product = null;
  this._onSuccess = null;
  this._onCancel = null;
  this._cancelButton = false;
  this._presenter = null;
  this._endpoint = '';

  this.init = function () {
    this._notification = $('#Notification');
    this._cancelButton ? $('.js-changeAddress__no-cancel_wrapper').remove() : $('.js-changeAddress__cancel_wrapper').remove();

    this._endpoint = this._getEndpoint();

    this._onEditAddressCallback = this._presenter.addCallbackToAction(this._endpoint, this._onEditAddress.bind(this));

    $(document).find('.js-changeAddress__cancel, .js--tray-header-cancel').on('click', this._onCancelClick.bind(this));
    $(this.node).find('#postal_code').on('change', this._upcaseField.bind(this));
    // updates account suite even when input field is empty
    this._presenter.extendViewMap({
      'account.suite': {
        set: function set(val) {
          if (!val) return '';
          return val;
        }
      }
    });
  };

  this.initAllReady = function () {
    $(this.node).show();
  };

  this._onEditAddress = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage({ action: this._endpoint }, { productLabel: this._product });
    } else if (response == 200) {
      var formAnalyticsID = $('.changeAddress__form').data('analytics-id');
      this._presenter.updateModel('account', data);
      this._analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      if (typeof this._onSuccess === 'function') this._onSuccess();
    } else {
      if (typeof this._onFailure === 'function') this._onFailure();
      this._notification.mogo().get();
    }
  };

  this._onCancelClick = function () {
    this._presenter.resetModels('account');
    if (typeof this._onCancel === 'function') this._onCancel();
  };

  this._onEditDisabledField = function () {
    var provinceField = $('#province');
    provinceField.mogo().showError();
    provinceField.mogo().showErrorLabel(true, "If you've changed provinces, get in touch with us.");
  };

  this._upcaseField = function (e) {
    return $(e.target).val($(e.target).val().toUpperCase());
  };

  this._hasAddressInNewFormat = function (e) {
    return this._presenter.models.account.addresses.filter(function (address) {
      return address.type === 'residential';
    });
  };

  // New address format - https://mogofintech.atlassian.net/browse/ACCT-596
  this._getEndpoint = function () {
    if (this._hasAddressInNewFormat() && this._hasAddressInNewFormat().length > 0) {
      return 'account.update_member_address';
    }
    return 'account.create_member_address';
  };

  this.destroy = function () {
    this._presenter.removeCallbackFromAction(this._endpoint, this._onEditAddressCallback);
  };
}